/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';
import { ConfigProvider } from 'antd';

import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { Globalstyle } from '@/globalStyled'; // style-component全局样式控制

import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';

import { getLocale, setLocale } from 'umi';

// antd语言包
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
// dayjs语言包
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/en';
// date-fns语言包
import enLocale from 'date-fns/locale/en-US';
import cnLocale from 'date-fns/locale/zh-CN';

// import webStorage from '@/utils/storageManager';
export const BrandContext = React.createContext('');

const ContextProviders = (props) => {
  const { language, brand, brandThemes, muiTheme } = props;

  const antdLangMap = {
    en: enUS,
    cn: zhCN,
  };

  const dateFnsLangMap = {
    en: enLocale,
    cn: cnLocale,
  };

  useMemo(() => {
    const dayJsLangMap = {
      en: 'en',
      cn: 'zh-cn',
    };

    const umiLangMap = {
      en: 'en-US',
      cn: 'zh-CN',
    };
    setLocale(umiLangMap[language], false);
    dayjs.locale(dayJsLangMap[language]);
    // webStorage.set('LANG', language);
    // const lang = webStorage.get('LANG');
    // console.log('💢felix => ContextProviders => LANG', lang);
  }, [language]);

  // console.log('💢felix => ContextProviders => language', language);
  // console.log('💢felix => ContextProviders => getLocale', getLocale());

  return (
    <ConfigProvider locale={antdLangMap[language]}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        locale={dateFnsLangMap[language]}
      >
        <BrandContext.Provider value={brand}>
          <StyledThemeProvider theme={brandThemes}>
            <MuiThemeProvider theme={muiTheme}>
              <CssBaseline />
              <Globalstyle />
              {props.children}
            </MuiThemeProvider>
          </StyledThemeProvider>
        </BrandContext.Provider>
      </LocalizationProvider>
    </ConfigProvider>
  );
};

export default ContextProviders;
